export const MOCK_TICKETS = [
  {
    id: '50',
    ref: '#TKT-050',
    title: 'Cannot access HR system after update',
    category: 'IT Support',
    subCategory: 'Software',
    status: 'new',
    priority: 'high',
    site: 'PDK',
    assignee: null,
    expectedResolution: null,
    progressPct: 0,
    openedAgo: '2 hours ago',
    updatedAgo: '2 hours ago',
    timeline: [
      { type: 'created', label: 'Ticket submitted by Ahmad Abdullah', time: 'Today, 9:05 AM' },
    ],
  },
  {
    id: '49',
    ref: '#TKT-049',
    title: 'Network connectivity issue in Block A',
    category: 'IT Support',
    subCategory: 'Network',
    status: 'in_progress',
    priority: 'medium',
    site: 'PDK',
    assignee: { name: 'Ahmad Hafiz', initials: 'AH' },
    expectedResolution: 'Today, 5:00 PM',
    progressPct: 55,
    openedAgo: '2 days ago',
    updatedAgo: '1 day ago',
    timeline: [
      {
        type: 'reply',
        label: 'Staff replied — Ahmad Hafiz',
        body: "We've identified the issue with the access point. Our team is on-site and working on the fix.",
        time: 'Today, 10:22 AM',
      },
      { type: 'status', label: 'Status changed to In progress', time: 'Yesterday, 4:15 PM' },
      { type: 'created', label: 'Ticket submitted by Ahmad Abdullah', time: 'Yesterday, 9:05 AM' },
    ],
  },
  {
    id: '48',
    ref: '#TKT-048',
    title: 'Printer not responding on 3rd floor',
    category: 'IT Support',
    subCategory: 'Hardware',
    status: 'open',
    priority: 'low',
    site: 'PDK',
    assignee: null,
    expectedResolution: null,
    progressPct: 10,
    openedAgo: '2 days ago',
    updatedAgo: '2 days ago',
    timeline: [
      { type: 'created', label: 'Ticket submitted by Ahmad Abdullah', time: '2 days ago, 11:30 AM' },
    ],
  },
  {
    id: '45',
    ref: '#TKT-045',
    title: 'Email account password reset request',
    category: 'IT Support',
    subCategory: 'Account',
    status: 'resolved',
    priority: 'low',
    site: 'PDK',
    assignee: { name: 'Siti Rahmah', initials: 'SR' },
    expectedResolution: null,
    progressPct: 100,
    openedAgo: '4 days ago',
    updatedAgo: '4 days ago',
    timeline: [
      { type: 'resolved', label: 'Ticket resolved by Siti Rahmah', time: '4 days ago, 3:00 PM' },
      { type: 'created', label: 'Ticket submitted by Ahmad Abdullah', time: '4 days ago, 9:00 AM' },
    ],
  },
]

export function getTicketById(id) {
  return MOCK_TICKETS.find((t) => t.id === id) ?? null
}
